module.exports = __webpack_public_path__ + "img/hr-defender-robot.8e2413a0.png";